import type { AppTestCaseGroup } from '../../common/components/ApplicationConfigPage/types'
import { Text } from '../../common/designs'

interface Props {
  application: AppTestCaseGroup
}

const ApplicationNameCell = ({ application }: Props) => (
  <Text size='s' className='min-w-0 truncate font-medium text-gray-900'>
    {application.appName}
  </Text>
)

export default ApplicationNameCell
